import React, { useEffect, useState, useRef } from "react";
import { BsGoogle, BsStripe } from "react-icons/bs";
import { FaSalesforce, FaSnowflake } from "react-icons/fa";
import { PiFigmaLogo, PiNoteBlankLight, PiOpenAiLogo } from "react-icons/pi";
import { RiAnthropicFill } from "react-icons/ri";
import { SiPostgresql, SiGmail, SiShopify, SiSlack, SiNotion } from "react-icons/si";
import { TbBrandGmail } from "react-icons/tb";
import { useNavigate } from "react-router-dom";

const ALL_INTEGRATIONS = [
  {
    name: "OpenAI",
    icon: <PiOpenAiLogo />,
    desc: "Build intelligent features with powerful GPT models and AI automation."
  },
  {
    name: "SalesForce",
    icon: <FaSalesforce />,
    desc: "Sync contacts, leads, and CRM data instantly with Salesforce integration."
  },
  {
    name: "Stripe",
    icon: <BsStripe />,
    desc: "Integrate Stripe for seamless and secure payments, subscriptions, and billing."
  },
  {
    name: "Figma",
    icon: <PiFigmaLogo />,
    desc: "Import designs from Figma to turn mockups into functional interfaces."
  },
  {
    name: "Anthropic",
    icon: <RiAnthropicFill />,
    desc: "Use Claude models for advanced reasoning, AI assistants, and workflows."
  },
  {
    name: "PostgreSQL",
    icon: <SiPostgresql />,
    desc: "Connect to PostgreSQL databases for fast, scalable, structured data storage."
  },
  {
    name: "Workspace",
    icon: <BsGoogle />,
    desc: "Integrate Google Workspace for email, calendars, drive access, and user sync."
  },
  {
    name: "Shopify",
    icon: <SiShopify />,
    desc: "Sync products, orders, inventory, and storefront data with Shopify."
  },
  {
    name: "Slack",
    icon: <SiSlack />,
    desc: "Automate messaging, alerts, and workflows directly within Slack channels."
  },
  {
    name: "Notion",
    icon: <SiNotion />,
    desc: "Connect to Notion to manage docs, databases, tasks, and team knowledge."
  }
];


const InfiniteIntegrations = ({ interval = 3000 }) => {
  const [feed, setFeed] = useState([]);
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      const nextItem = ALL_INTEGRATIONS[counter % ALL_INTEGRATIONS.length];

      setFeed((prev) => {
        const updated = [
          { ...nextItem, id: Date.now() },
          ...prev,
        ];

        return updated.slice(0, 1);
      });

      setCounter((c) => c + 1);
    }, interval);

    return () => clearInterval(timer);
  }, [counter, interval]);

  return (
    <div className="input_menu">
      {feed.map((item) => (
        <div key={item.id} className="input_menu_item fade-in">
          <div className="input_menu_item_header">
            <i>{item.icon}</i>
            <span>{item.name}</span>
          </div>
          <span className="input_menu_item_desc">{item.desc}</span>
        </div>
      ))}
    </div>
  );
};


const TypingEffect = ({ phrases = [], speed = 200, pause = 2000 }) => {
  const [text, setText] = useState("");
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [isFocused, setIsFocused] = useState(false); // track focus
  const contentRef = useRef(null);

  useEffect(() => {
    if (isFocused) return; // pause typing if user is interacting

    const currentPhrase = phrases[phraseIndex % phrases.length];
    let timeout;

    if (!isDeleting && text.length < currentPhrase.length) {
      setIsPaused(false);
      timeout = setTimeout(() => {
        setText(currentPhrase.slice(0, text.length + 1));
      }, speed);
    } else if (isDeleting && text.length > 0) {
      setIsPaused(false);
      timeout = setTimeout(() => {
        setText(currentPhrase.slice(0, text.length - 1));
      }, speed / 2);
    } else if (!isDeleting && text.length === currentPhrase.length) {
      setIsPaused(true);
      timeout = setTimeout(() => setIsDeleting(true), pause);
    } else if (isDeleting && text.length === 0) {
      setIsPaused(false);
      setIsDeleting(false);
      setPhraseIndex((prev) => prev + 1);
    }

    return () => clearTimeout(timeout);
  }, [text, isDeleting, phraseIndex, phrases, speed, pause, isFocused]);

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.innerHTML = `${text}<span class="caret ${isPaused ? "blink" : ""}">|</span>`;
    }
  }, [text, isPaused]);

  return (
    <div
      ref={contentRef}
      className="input_home"
      aria-placeholder="Test"
      contentEditable
      suppressContentEditableWarning={true}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
    />
  );
};



const MainTitle = () => {
  const navigate = useNavigate()
  const navigateUrl = () => {
    window.location.href = "https://t0.erioon.com/join-waitlist";
  }
  return (
    <div className="main_title_cont">
      <h1 className="main_title_home fade-in">Memory for AI.</h1>
      <h3 className="main_subtitle_home fade-in">
        Store information seamlessly and let your AI recall only what matters.
      </h3>
      <div className="start_now_btn_cont">
      <button className="start_now_btn" onClick={navigateUrl}>
        Join waitlist
      </button>
       {/* <button className="start_now_btn" onClick={() => navigate("/register")}>
        Start now
      </button> */}
       <button className="start_now_btn" onClick={() => window.open(`/dev-docs/introduction`, '_blank')} >
        <PiNoteBlankLight/> Developer docs
      </button> 
      </div>
      {/* <button className="start_now_btn fade-in" onClick={() => navigate("/register")}>Start now</button> */}
      {/* <div className="input_home_cont">
        <TypingEffect
          phrases={[
            "Build a CRM with Salesforce integration",
            "Create a mobile app for food delivery",
            "Generate a landing page for my startup",
            "Develop an AI chatbot for customer support",
            "Set up automated email campaigns",
            "Design a dashboard for analytics",
            "Integrate Stripe payments into my website",
            "Create a social media content scheduler",
            "Build a task management tool for teams",
            "Generate code for a blog platform",
            "Connect my app to Google Calendar",
            "Automate data entry from spreadsheets",
            "Build a recommendation system for products",
            "Deploy a portfolio website for my business",
            "Create an AI assistant to handle support tickets",
          ]}

          speed={40}
          pause={1500}
        />
        <div className="input_home_footer">
          <button className="input_home_footer_btn"><i className="fa-solid fa-arrow-up"></i></button>
          <div className="input_home_footer_cont">
            <button className="input_home_footer_btn_second"><i className="fa-solid fa-plus"></i></button>
            <button className="input_home_footer_btn_second"><i className="fa-solid fa-microphone"></i></button>
          </div>
        </div>


      </div> */}

      <div className="ai_ribbons_cont">
        {/* <i className="ai_ribbons"><TbGalaxy/></i> */}
      </div>

    </div>
  );
};

export default MainTitle;
